import DatesTable from '../components/dates-table';
import QuestionsBox from '../components/questions-box';
import QuestionsForm from '../components/questions-form';

export default {	
  init() {
    // JavaScript to be fired on the home page
    new DatesTable($('#dates-table'));
    new QuestionsBox($('.c-questions-box'));
    new QuestionsForm($('.c-questions-form'));
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js